export default "__VITE_ASSET__oiR$R2Do__"